import { GrillAssistanceInfo } from '@components/Product/Details/_GrillAssistanceInfo';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { LinkProps } from '@repo/ui/src/types/link';
import DocumentIcon from '@repo/ui/src/components/Icons/DocumentIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import InformationIcon from '@repo/ui/src/components/Icons/InformationIcon';
import Markdown from '@repo/ui/src/components/Markdown';

export interface AdditionalInformationProps {
  ownerManual?: {
    ownerManualLink: Array<LinkProps>;
  };
  prop65?: {
    title: string;
    warningBody: string;
  };
  onAnimFinishedInfoAccordion?: () => void;
  showGrillAssistanceInfo?: boolean;
  dark?: boolean;
}

const AdditionalInformation = ({
  ownerManual,
  prop65,
  showGrillAssistanceInfo = false,
  dark = false,
}: AdditionalInformationProps) => {
  if (!showGrillAssistanceInfo && !prop65 && !ownerManual?.ownerManualLink?.length) return null;

  return (
    <div
      className={classNames(
        'tra-text-body-2 grid gap-y-4 md:gap-y-6 p-4 md:p-6',
        dark ? 'bg-neutral-600 text-white' : 'bg-warm-200',
      )}
    >
      {showGrillAssistanceInfo && <GrillAssistanceInfo />}
      {prop65 && (
        <div className="gap-x-2 flex items-baseline">
          <span>
            <InformationIcon />
          </span>

          <Markdown
            className={classNames(
              'tra-text-web-body-xl !mb-0',
              dark ? 'text-white' : 'bg-warm-200',
            )}
          >
            {prop65.warningBody}
          </Markdown>
        </div>
      )}
      {ownerManual?.ownerManualLink?.length && prop65 && (
        <hr className={dark ? 'border-neutral-500' : 'border-warm-100'} />
      )}
      {ownerManual?.ownerManualLink?.length && (
        <div className="flex items-baseline gap-x-2">
          <span className="w-6">
            <DocumentIcon role="presentation" />
          </span>
          <Anchor
            {...ownerManual?.ownerManualLink[0]}
            isExternal={!!ownerManual?.ownerManualLink[0]?.externalLink}
          />
        </div>
      )}
    </div>
  );
};

export default AdditionalInformation;
